// extracted by mini-css-extract-plugin
export var wrapper = "HorizontalScroll-module--wrapper--1ywk2";
export var tabletWrapper = "HorizontalScroll-module--tabletWrapper--3x8CD";
export var spinAround = "HorizontalScroll-module--spinAround--1s12Q";